import { useTranslation } from 'react-i18next';

export default function Hero() {
  const { t } = useTranslation();

  const scrollToForm = () => {
    const element = document.getElementById('formulario');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const openWhatsApp = () => {
    const url = 'https://wa.me/351963467122?text=Olá, gostaria de pedir um orçamento';
    try {
      const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
      if (!newWindow) {
        console.warn('Popup blocked. Please allow pop‑ups for this site.');
      }
    } catch (err) {
      console.error('Failed to open WhatsApp link:', err);
    }
  };

  return (
    <section className="relative min-h-[calc(100vh+189px)] flex items-center justify-center overflow-hidden">
      {/* Fundo preto texturizado */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/28018c75fb69a60fb5940cade1458994.jpg"
          alt="Background texturizado"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-black/40"></div>
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 lg:px-12 text-center w-full">
        {/* Logomarca posicionada estrategicamente */}
        <div className="mb-0 -mt-3">
          <img
            src="https://static.readdy.ai/image/f2bd418b0bfbfafabfbde3d1f67690ab/be3b795cf577578dc84a4afcd48bbd61.png"
            alt="Olhar Criativo - Agência de Marketing Digital no Algarve"
            className="h-64 md:h-[21rem] lg:h-[25rem] mx-auto object-contain drop-shadow-2xl"
          />
        </div>

        <h1 className="text-5xl md:text-7xl lg:text-8xl font-bold text-white mb-6 leading-tight">
          {t('hero.titulo')}<br />{t('hero.titulo2')}
        </h1>

        <p className="text-xl md:text-2xl text-white/90 mb-12 max-w-3xl mx-auto leading-relaxed">
          {t('hero.subtitulo')}
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            onClick={scrollToForm}
            className="bg-white text-black px-8 py-4 rounded-full text-base font-semibold hover:bg-gray-100 transition-all cursor-pointer whitespace-nowrap shadow-lg"
          >
            {t('hero.botaoOrcamento')}
          </button>
          <button
            onClick={openWhatsApp}
            className="bg-transparent border-2 border-white text-white px-8 py-4 rounded-full text-base font-semibold hover:bg-white hover:text-black transition-all cursor-pointer whitespace-nowrap"
          >
            {t('hero.botaoWhatsapp')}
          </button>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </div>
    </section>
  );
}
